import { IProject } from 'shared/interfaces'

export const useGlobalProjectFlags = ({ project, userZoneId }: { project: IProject; userZoneId: number}) => {
  const localizedProjectInUserZone = project?.children?.find((project: IProject) => +project.label_id === userZoneId)
  const isLocalizing = localizedProjectInUserZone?.global_status === 'PREPARING'
  const isLocalized = localizedProjectInUserZone?.global_status === 'PUBLISHED'

  return {
    isLocalized,
    localizedProjectInUserZone,
    isLocalizing
  }
}
